import { render } from "./QrcodeCapture.vue?vue&type=template&id=b4532170&lang=html&bindings={\"worker\":\"props\",\"onChangeInput\":\"options\",\"processFile\":\"options\"}"
import script from "./QrcodeCapture.vue?vue&type=script&lang=js"
export * from "./QrcodeCapture.vue?vue&type=script&lang=js"
script.render = render

export default script